import axios from 'axios';

export const HTTP = axios.create({
    baseURL: process.env.API_HOST,
    headers: {
        Authorization: 'Bearer '+process.env.API_TOCKEN
    }
});
export const HTTP_SECURE = axios.create({
    baseURL: process.env.API_SECURE_URL,
    headers: {
        Authorization: 'Bearer '+process.env.API_TOCKEN
    }
});

export const HTTP_STAT = axios.create({
  headers: {
    'Content-Type': "application/x-www-form-urlencoded"
  }
});

export function  HTTP_CHECK() {
        let baseUrl = process.env.API_CHECK_TOKEN;
        let headers = {
            Authorization:  'Bearer ' +  process.env.API_TOCKEN,
            'Content-Type':  "application/x-www-form-urlencoded",
};
        let options={
            baseURL: baseUrl,
            headers:headers,
        }
        console.log('options', options);
    return axios.create(options);

}


// WEBPACK FOOTER //
// ./src/core/http/http-common.js